
import { clientInstance } from "../config/config";


export let addToWaitlistAPI = async (email) => {
    return clientInstance.post(`/waitlist`, { email });
};